// 55吃瓜 - 爆梗故事与分类数据

export interface Category {
  key: string;
  label: string;
  emoji: string;
  tagline: string;
}

export interface Story {
  id: number;
  cat: string;
  tag: string;
  title: string;
  snippet: string;
  body: string[];
  reads: string;
  likes: number;
  date: string;
  image: string;
}

export const categories: Category[] = [
  { key: "she", label: "社死现场", emoji: "💥", tagline: "每一条都值得换座城市生活" },
  { key: "job", label: "职场迷惑", emoji: "🧑‍💻", tagline: "打工人の离谱日常图鉴" },
  { key: "family", label: "家庭闹剧", emoji: "🏠", tagline: "亲爹亲妈的骚操作合集" },
  { key: "love", label: "恋爱修罗场", emoji: "💘", tagline: "感情翻车现场实录" },
  { key: "game", label: "游戏名场面", emoji: "🎮", tagline: "开黑五分钟尴尬一整天" },
  { key: "food", label: "吃货翻车", emoji: "🍜", tagline: "干饭人的大型社死现场" },
];

export const stories: Story[] = [
  {
    id: 1,
    cat: "she",
    tag: "社死现场",
    title: "给老板唱生日歌，结果唱到一半才发现认错了人",
    snippet: "一口气没憋住，把半个月工资的尴尬都唱进了歌词里。",
    body: [
      "事情是这样的，我公司每月中旬会给当月的寿星开个小会。那天我端着蛋糕进会议室，灯光一关，大家起哄让我开个头给‘寿星’唱生日歌。",
      "我清了清嗓子，深情对着正前方那位西装大哥开唱，还越唱越投入，临了补了一句‘祝您今年项目全过，房贷也提前还清’。",
      "全场安静了三秒。我旁边同事憋着笑扯我袖子：亲，寿星今天请假了，你唱的是我们空降的审计组长。",
      "我当场想从十八楼跳下去，结果审计组长还鼓掌了：‘唱得不错，就是那句房贷，我确实在愁。’整个会议室从此多了一个梗：开工先给老板唱一首《知足》。",
    ],
    reads: "12.6万",
    likes: 3842,
    date: "2026-09-04",
    image: "https://readdy.ai/api/search-image?query=playful%20flat%20cartoon%20editorial%20illustration%20of%20an%20embarrassed%20office%20worker%20singing%20to%20a%20surprised%20boss%20in%20a%20dark%20meeting%20room%2C%20warm%20cream%20background%2C%20vivid%20coral%2C%20lime%20and%20mustard%20accents%2C%20no%20text&width=640&height=420&seq=story-01&orientation=landscape",
  },
  {
    id: 2,
    cat: "job",
    tag: "职场迷惑",
    title: "把工作群当成相亲群，一句‘你好骚啊’发遍了全公司",
    snippet: "当时只想着整活，没想过领导也在群里。",
    body: [
      "午休摸鱼，我把一个小群的名字看串了，把调侃同事的一句话直接发进了公司大群。",
      "发送成功的瞬间，我甚至没察觉，还美滋滋地刷起了微博。直到隔壁工位的老哥给我看手机，我的天塌了：消息上面明晃晃躺着领导的一句‘？’。",
      "我脑子飞速运转，决定亡羊补牢，补了句‘不好意思发错了’。结果同组二货秒回：姐你刚才说谁骚呢，是不是上回那个客户。",
      "群里从中午安静到下班。晚上领导单独找我，不是批评，是让我明天开组会时把这句话解释清楚。于是我第二天，当着全组三十几号人，鞠了一躬：领导最正经，是我想多了。",
    ],
    reads: "18.9万",
    likes: 5210,
    date: "2026-09-03",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20shocked%20office%20worker%20staring%20at%20a%20giant%20phone%20showing%20a%20group%20chat%20on%20a%20big%20screen%2C%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20coral%20and%20lime%20accents%2C%20no%20text&width=640&height=420&seq=story-02&orientation=landscape",
  },
  {
    id: 3,
    cat: "family",
    tag: "家庭闹剧",
    title: "我妈把我三岁的丑照印成了挂历，挂在了全家最显眼的位置",
    snippet: "今年过年走亲戚，我的黑历史销量比春联还高。",
    body: [
      "事情的起因，是我妈整理旧相册时翻出一张我三岁啃西瓜的照片：门牙缺俩，糊了一脸西瓜汁，笑得像个坏掉的葫芦。",
      "她当场拍案叫绝，说要让这份快乐‘进千家万户’。于是，某天我回家，发现客厅正中央挂起了一本大挂历，每一页都是我。",
      "三月的我是流鼻涕版本，六月的我是吃手手版本，十一月的我是被鸡追得嗷嗷哭版本。最绝的是封面，我妈还配了四个大字：家有一宝。",
      "过年来串门的七大姑八大姨人手一份合影，我爸甚至把挂历做成了手机壳。我试图反抗，我妈一锤定音：等你成家，这份快乐还要继续传承。",
    ],
    reads: "9.8万",
    likes: 2990,
    date: "2026-09-02",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20toddler%20eating%20watermelon%20printed%20large%20on%20a%20hanging%20wall%20calendar%20in%20a%20cozy%20living%20room%2C%20funny%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-03&orientation=landscape",
  },
  {
    id: 4,
    cat: "love",
    tag: "恋爱修罗场",
    title: "相亲时吐槽了对方的熟人，回家才发现相亲对象是那人的闺蜜",
    snippet: "世界很小，小到我说完坏话对方就点头确认：‘那是我的铁闺蜜。’",
    body: [
      "周末被爸妈安排去相亲，男生条件普通，聊得还行。为了显得幽默，我顺嘴吐槽了上周一个相亲对象，说人家抠门，喝奶茶都要AA。",
      "对面姑娘听完脸色一变，礼貌地放下筷子：你说的那位，是我大学四年的铁闺蜜，她现在……是我室友。",
      "空气瞬间凝固。我脑子飞速运转补救，憋出一句：那她人其实挺好的，我就是劝你闺蜜们别老给她介绍抠门的。",
      "结局自然没戏。回家路上我复盘了一路，最扎心的是我妈还打电话来问战况，我咬着牙回：战况很惨烈，我把自己炸没了。",
    ],
    reads: "15.4万",
    likes: 4460,
    date: "2026-09-01",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20an%20awkward%20dinner%20date%20at%20a%20restaurant%20table%20with%20two%20people%20and%20a%20speech%20bubble%2C%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-04&orientation=landscape",
  },
  {
    id: 5,
    cat: "game",
    tag: "游戏名场面",
    title: "开黑时麦没关，我把‘这波能打赢就是见鬼’喊进了全队语音",
    snippet: "队友没说话，但我的耳机传来了一阵整齐的退游音。",
    body: [
      "平时开黑我都静音，那天手一抖没关麦。队里有个菜鸟一直送人头，我气得当着全队开始输出：‘这波能赢，我当场把键盘吃了。’",
      "结果话音刚落，我血C的队友真的带飞了，一把翻盘赢了。房间里沉默了五秒，然后几个人开始起哄：键盘到了没有？",
      "我嘴硬：我说的是一整局，不算。结果那老哥更绝，直接把我刚才那两句剪了音效发群里，标题叫《打脸实录》。",
      "从此我在那个车队有了个新外号，叫‘键盘侠’。每次开局之前，队长都会先问我一句：今天键盘带了吗？",
    ],
    reads: "11.2万",
    likes: 3325,
    date: "2026-08-30",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20gamer%20at%20a%20colorful%20desk%20with%20headset%20and%20keyboard%20about%20to%20eat%20it%2C%20funny%20comic%20style%2C%20warm%20cream%20background%2C%20lime%20and%20coral%20accents%2C%20no%20text&width=640&height=420&seq=story-05&orientation=landscape",
  },
  {
    id: 6,
    cat: "food",
    tag: "吃货翻车",
    title: "自助餐回本计划：吃到一半发现店家在隔壁桌开了新的一轮",
    snippet: "我以为我在薅羊毛，结果店家早就预判了我的预判。",
    body: [
      "一直坚信吃自助要‘扶墙进扶墙出’。那天我开足马力，先是两盘虾，再是三份牛排，中途还往胃里塞了两碗冰淇淋。",
      "吃到第七八轮，我已经撑得只能弓着背慢慢走。抬眼一看，隔壁新进来的一桌已经开始第二轮加单，店家笑眯眯地给人家补新鲜刺身。",
      "我心一横，觉得还能再战，结果刚站起来打嗝，一串虾卡喉咙差点当场表演。旁边服务员赶紧递水，还贴心安慰：没事姐，咱这儿不亏待自己人也别太拼。",
      "最后我扶着墙出去，走了两条街都在后悔那碗冰淇淋。第二天一上秤，我悟了：回本的从来不是胃，是我为自助献祭掉的尊严。",
    ],
    reads: "13.7万",
    likes: 4180,
    date: "2026-08-29",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20an%20overstuffed%20person%20surrounded%20by%20piles%20of%20buffet%20food%20plates%20at%20a%20restaurant%2C%20funny%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-06&orientation=landscape",
  },
  {
    id: 7,
    cat: "she",
    tag: "社死现场",
    title: "图书馆睡觉打呼，还梦话喊出了偶像的名字",
    snippet: "那天下午，图书馆的监控替我把过程拍得清清楚楚。",
    body: [
      "期末周图书馆抢座不易，我占了窗边好位置，本打算认真背书，结果一翻书眼睛就自动合上。",
      "再睁眼是被自己吵醒的。没错，我做梦梦见偶像开演唱会给我递麦，我激动地喊了一句全场都能听见的‘哥哥娶我’！",
      "醒来时周围三排的人都齐刷刷回头看我，我尴尬得想当场装睡。结果对面小哥递来一张纸条，上面写着：帮你要到票了，下次喊小声点。",
      "那纸条我到现在还留着。倒不是想感谢，主要是想提醒自己：图书馆的桌子，是拿来读书的，不是拿来当演唱会现场的。",
    ],
    reads: "10.5万",
    likes: 3011,
    date: "2026-08-28",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20student%20sleeping%20and%20dreaming%20on%20a%20library%20desk%20with%20books%20while%20others%20stare%2C%20funny%20comic%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-07&orientation=landscape",
  },
  {
    id: 8,
    cat: "game",
    tag: "游戏名场面",
    title: "网吧五连跪当场卸载游戏，半小时后又默默回来续费",
    snippet: "卸载三分钟，后悔三小时，人类果然离不开电子竞技。",
    body: [
      "那天下午在网吧，我从三点打到六点，五连跪，掉得连亲妈排位都认不出我。盛怒之下我点开卸载，把那个图标从桌面一键清空。",
      "我走出网吧门，寒风一吹，热血上头的那股劲瞬间就凉了。站在门口我开始算账：会员还剩两小时，明天队友还要约我上分……",
      "于是半小时后，我又坐回了刚才那台机子，淡定地跟网管说：麻烦再帮我下载一下那个游戏。网管憋着笑：哥，是不是又赢了。",
      "我只能摆摆手：人这一生，总会为热爱的事反复卸载又重装。第二天上号，我直接改名‘戒了又回来’。",
    ],
    reads: "8.9万",
    likes: 2780,
    date: "2026-08-27",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20person%20at%20a%20computer%20desk%20returning%20to%20reinstall%20a%20game%20after%20storming%20out%20of%20a%20net%20cafe%2C%20funny%20comic%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-08&orientation=landscape",
  },
  {
    id: 9,
    cat: "love",
    tag: "恋爱修罗场",
    title: "想给前任发‘删了吧’，手滑发到了现对象那儿",
    snippet: "现对象沉默了十分钟，给我回了句：你手机里前任还挺多。",
    body: [
      "深夜emo上头，我酝酿了半天想给前任发一句‘删了吧，回不去了’，准备做个了断。结果手一抖，消息发进了现对象的对话框。",
      "对面先是回了一个问号，隔了十分钟，才慢悠悠补了一句：哟，原来你心里还有这么一位待删人士，手机里前任挺多啊。",
      "我当场冷汗就下来了，连夜解释了一百遍这是给共同好友的群发任务。现对象假装大度，第二天还是把我的备注改成了‘手滑大师’。",
      "吃一堑长一智，我现在给谁发消息之前，都要先把联系人名念出来确认三遍。爱情可以重来，手滑的尴尬不能重来。",
    ],
    reads: "16.8万",
    likes: 5010,
    date: "2026-08-26",
    image: "https://readdy.ai/api/search-image?query=flat%20cartoon%20illustration%20of%20a%20person%20tensely%20typing%20on%20a%20phone%20at%20night%20while%20a%20mistaken%20chat%20message%20appears%2C%20funny%20comic%20editorial%20style%2C%20warm%20cream%20background%2C%20no%20text&width=640&height=420&seq=story-09&orientation=landscape",
  },
];